import { useQuery } from '@tanstack/react-query';
import { categoriasApi } from '@/lib/api/core';
import { useAuthStore } from '@/lib/stores/authStore';

/**
 * FONTE ÚNICA DE TEMA do mandato.
 *
 * No protótipo existe UMA lista de temas (`const TEMAS=[...]`, proto:~470) e ela
 * serve tanto às solicitações quanto às ações — é por isso que a leitura
 * estratégica dos painéis consegue perguntar "qual tema com demanda não tem
 * ação em curso?" (proto:1208, `ACOES.some(a=>a.tema===x.l)`).
 *
 * Aqui esse vocabulário é dado real do gabinete: as categorias de módulo
 * `solicitacao` (`GET /core/categorias?modulo=solicitacao`), editáveis em
 * Configurações › Tipos. Elas são o catálogo de demandas do mandato — as
 * categorias de módulo `acao` são outra coisa ("Inauguração de obra", "Entrega
 * de equipamentos", "Projeto de lei", `seed.service.ts`), que descrevem o TIPO
 * do instrumento, não o assunto da demanda.
 *
 * Antes desta função, Solicitações liam esta lista e Ações usavam uma constante
 * fixa de 7 itens no próprio front. Os dois conjuntos não tinham UM literal em
 * comum, então a nota "Tema recorrente sem ação" acusava sempre o tema mais
 * demandado de não ter ação — mesmo quando tinha — e ainda oferecia o link
 * "Criar ação". Uma fonte só torna a comparação possível, do mesmo jeito que
 * `lib/navegacao.ts` unificou as três definições de navegação.
 */
export function useTemas() {
  const token = useAuthStore((s) => s.token) || '';

  const { data, isLoading, isError } = useQuery({
    queryKey: ['categorias', 'solicitacao'],
    queryFn: () => categoriasApi.list(token, 'solicitacao'),
    enabled: !!token,
  });

  return { temas: (data ?? []).map((c) => c.nome), isLoading, isError };
}
